import { useState } from 'react';
import ConfirmDialog from '@/components/ui/ConfirmDialog';
import { deleteWebhook } from './webhooks.service';
import type { WebhookEndpoint } from './types';

export interface DeleteWebhookConfirmProps {
  item: WebhookEndpoint | null;
  onClose: () => void;
  onDeleted: () => void;
}

export default function DeleteWebhookConfirm({
  item,
  onClose,
  onDeleted,
}: DeleteWebhookConfirmProps) {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    if (!item) return;
    setIsDeleting(true);
    try {
      await deleteWebhook(item.id);
      onDeleted();
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <ConfirmDialog
      isOpen={item !== null}
      onClose={onClose}
      onConfirm={handleConfirm}
      title="Excluir webhook?"
      message={
        <span>
          O endpoint{' '}
          <code style={{ fontFamily: 'monospace', background: '#f3f4f6', padding: '1px 5px', borderRadius: '3px' }}>
            {item?.url ?? ''}
          </code>{' '}
          será removido permanentemente, junto com todo o histórico de entregas. Esta ação não pode ser desfeita.
        </span>
      }
      confirmText="Excluir agora"
      cancelText="Cancelar"
      type="danger"
      isConfirming={isDeleting}
      confirmingText="Excluindo..."
    />
  );
}
